var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "cell-full title" }, [
        _vm._v(
          _vm._s(
            _vm.investment
              ? _vm.investment.name
              : "Sem investimento selecionado."
          )
        )
      ])
    ]),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "cell-full label" }, [_vm._v(" Código: ")]),
      _c("div", { staticClass: "cell-full ctrl" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.newCode,
              expression: "newCode"
            }
          ],
          attrs: { type: "text" },
          domProps: { value: _vm.newCode },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.newCode = $event.target.value
            }
          }
        })
      ])
    ]),
    _c("div", { staticClass: "row option" }, [
      _c("div", { staticClass: "cell-50 ctrl" }, [
        _c(
          "button",
          {
            staticClass: "btn-confirm",
            attrs: { type: "button", disabled: _vm.notfilled },
            on: { click: _vm.updateCode }
          },
          [_vm._v("Alterar")]
        )
      ]),
      _c("div", { staticClass: "cell-50 ctrl" }, [
        _c(
          "button",
          {
            staticClass: "btn-cancel",
            attrs: { type: "button" },
            on: { click: _vm.dismiss }
          },
          [_vm._v("Cancelar")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }